module.exports = __webpack_public_path__ + "img/smart-query.8cc9136d.svg";